import { Show } from "react-admin";
import CampaignRankingResults from "./components/CampaignRankingResults";

const ShowRankingResults = () => {
  return (
    <Show title="Класиране по специалности">
      <CampaignRankingResults />
    </Show>
  );
};

export default ShowRankingResults;
